import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { 
    Form, 
    Input, 
    Button,
    Icon,
    Row,
    Col,
    message
} from 'antd';

import uid from 'uid';
import { DEFAULT_MESSAGES } from '~/constants/default-messages.constants';
import axios from 'axios';
import { getSubdomain } from '~/helpers/getSubdomain';

import InputMask from '~components/UI/InputMask'

import { msgs } from './msgs';

import { 
    Container,
    BotWrapper,
    BotHeader,
    BotTitle,
    ChatWrapper,    
    ChatMessage,
    FormWrapper
} from './styles';

import { Typing } from './Typing';

export const BotForm = ({
    form,
    data,
    isCheckingIfFormIsValid,
    token,
    indicated_by_id
}) => {
    const [currentMsg, setCurrentMsg] = useState(null);
    const [chat, setChat] = useState([]);
    const [typing, setTyping] = useState(true);
    const [id, setId] = useState(null);

    const chatRef = useRef(null);
    const inputRef = useRef(null);

    async function sendData() {
        let chatValues = {}
        // eslint-disable-next-line array-callback-return
        chat.map((c) => {
            if(c.field_name && c.text && c.from === 'user') {
                chatValues = {
                    ...chatValues,
                    [c.field_name]: c.text
                }
            }
        });

        // check if object is empty
        if(Object.keys(chatValues).length === 0) {
            return;
        }

        try {
            await axios.post(
              `${process.env.REACT_APP_API}/indications/${token}/log`,
              {
                ...chatValues,
                id: id,
                indicated_by_id: indicated_by_id,
              },
              {
                headers: {
                  "X-Tenant": getSubdomain(),
                },
              }
            ).then(response => {
                setId(response.data.data.id);
            });
    
          } catch (error) {
            const { response } = error;
            if (response) {
              if (response.status === 404 || response.status >= 500) {
                message.error(DEFAULT_MESSAGES['high-demand']);
              }
            }
        }
    }

    useEffect(() => {
        if (msgs && msgs[currentMsg] && !msgs[currentMsg].input) {
            setTyping(true);

            // wait 2 seconds before sending the next message
            setTimeout(() => {
                setChat([...chat, msgs[currentMsg]]);
                setCurrentMsg(currentMsg + 1);
                setTyping(false);

                // scroll to the bottom of the chat
                const scrollHeight = chatRef.current.scrollHeight;
                const clientHeight = chatRef.current.clientHeight;
                chatRef.current.scrollTo({ top: scrollHeight - clientHeight, behavior: 'smooth' });

                sendData();
            }, 1500);
        }
    }, [currentMsg]);

    useLayoutEffect(() => {
        if (currentMsg === null) {
            return;
        }

        if (msgs[currentMsg] && msgs[currentMsg].input && inputRef.current && inputRef.current.focus) {
            inputRef.current.focus();
        }
    }, [currentMsg]);

    useEffect(() => {
        if(data !== null){
            setCurrentMsg(0);
        }
    }, [data]);

    const handleNext = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                setChat([...chat, { 
                    id: uid(), 
                    text: values.text,
                    from: 'user',
                    field_name: msgs[currentMsg].field_name
                }]);
                setCurrentMsg(currentMsg + 1);
            }
        });
    }


    if(!isCheckingIfFormIsValid) {
        return (
            <Container>
                <BotWrapper>
                    <BotHeader>
                        <BotTitle>Formulário Indisponível</BotTitle>
                    </BotHeader>
                    <ChatWrapper ref={chatRef}>
                        <ChatMessage className="bot">
                            Este formulário não está mais disponível.
                        </ChatMessage>
                    </ChatWrapper>
                </BotWrapper>
            </Container>
        )
    }

    if (currentMsg === null || data === null) {
        return (
            <Container>
                <BotWrapper>
                    <BotHeader>
                        <BotTitle>Chat</BotTitle>
                    </BotHeader>
                    <ChatWrapper ref={chatRef}>
                        {typing && (
                            <ChatMessage className="bot">
                                <Typing />
                            </ChatMessage>
                        )}
                    </ChatWrapper>
                </BotWrapper>
            </Container>
        )
    }

    return (
        <Container>
            <BotWrapper>
                <BotHeader>
                    <BotTitle>{data.name}</BotTitle>
                </BotHeader>
                <ChatWrapper ref={chatRef}>
                    {chat.map((msg, index) => {
                        if(msg.image) {
                            if (msg.image === '$logo$') {
                                return <ChatMessage 
                                    className="bot"
                                    key={index}>
                                    <img src={data.logo} alt="logo" />
                                </ChatMessage>;
                            }
                            return <ChatMessage 
                                className="bot"
                                key={index}>
                                <img src={msg.image} alt="logo" />
                            </ChatMessage>;
                        }

                        if(msg.text === '$description$') {
                            return <ChatMessage 
                                className="bot"
                                key={index}>
                                <p>{data.description}</p>
                            </ChatMessage>;
                        }

                        return <ChatMessage 
                                    className={msg.from}
                                    dangerouslySetInnerHTML={{ __html: msg.text }}
                                    key={index} />;
                    })}
                    {typing && (
                        <ChatMessage className="bot">
                            <Typing />
                        </ChatMessage>
                    )}
                    {msgs[currentMsg] && msgs[currentMsg].input && (
                        <Form onSubmit={handleNext}>
                            <Row>
                                <Col span={18} offset={6}>
                                    {msgs[currentMsg].input === 'text' && (
                                        <FormWrapper>
                                            <Form.Item>
                                                {form.getFieldDecorator('text', {
                                                    rules: [{ required: true, message: 'Campo obrigatório' }],
                                                })(<Input placeholder="Sua resposta..." ref={inputRef} />)}
                                            </Form.Item>
                                            <Button type="primary" block htmlType="submit">
                                                <Icon type="right" />
                                            </Button>
                                        </FormWrapper>
                                    )}
                                    {msgs[currentMsg].input === 'phone' && (
                                        <FormWrapper>
                                            <Form.Item>
                                                {form.getFieldDecorator('text', {
                                                    rules: [{ required: true, message: 'Campo obrigatório' }],
                                                })(<InputMask 
                                                    mask="(99) 9999tt999?" 
                                                    formatChars={{"9": "[0-9]", "t": "[0-9\-]", "?": "[0-9 ]"}} 
                                                    maskChar={null} 
                                                    placeholder="Sua resposta..." 
                                                    getRef={inputRef}
                                                />)}
                                            </Form.Item>
                                            <Button type="primary" block htmlType="submit">
                                                <Icon type="right" />
                                            </Button>
                                        </FormWrapper>
                                    )}
                                </Col>
                            </Row>
                        </Form>
                    )}
                </ChatWrapper>
            </BotWrapper>
        </Container>
    );
}

export default Form.create({ name: 'bot_form' })(BotForm);